import React from "react";


const ProcessHistory = ({setIndex, content}) => {
  return (
    <div className="history-roadmap-wrap">
      <div className="roadmap-line-shape">
        <span className="dot-one pulse-one"></span>
        <span className="dot-two pulse-two"></span>
      </div>

      <ul className="list-wrap">
        {content.map((service, index) => (
            <li
            className="wow fadeInDown"
            data-wow-delay=".2s"
            data-wow-duration="1.5s"
            onClick={() => setIndex(index)}
          >
            <span className="dot pulse-three"></span>
            <div className="content">
              <h5 className="title">{service.heading}</h5>
              {/* <p>January 14 th</p> */}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProcessHistory;
